// import ConfirmDialog from "../confirm-dialog/ConfirmDialog";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import Iconify from "../iconify";
import IconCode from "@/src/lib/iconCode";
import CustomButton from "@/src/lib/ui/Button";

const ErrorPopup = ({ open, onClose, errorMessage }) => {
    return (
        <ConfirmDialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            title={
                <div className="flex flex-row items-center gap-1">
                    <Iconify
                        icon={IconCode.alert2}
                        width={30}
                        color="#FFAB00"
                    />
                    <h6 className="text-black text-lg font-bold">Alert!</h6>
                </div>
            }
            content={
                <>
                    <p className="text-gray-700 text-sm">{errorMessage}</p>
                    <div className="flex justify-end mt-2">
                        <CustomButton
                            variant="contained"
                            onClick={onClose}
                            className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold text-sm rounded-md px-4 py-2 rounded-xs capitalize"
                        >
                            Dismiss
                        </CustomButton>
                    </div>
                </>
            }
            isCancel
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 2,
                    },
                },
            }}
        />
    );
};

export default ErrorPopup;
